export default {
  header: 'Information for {0}',
  loadData: 'Load',
  load: 'Load {0}',
  orderNo: 'Order No.',
  partNo: 'Part No.',
  partDesc: 'Part description',
  targetQuantity: 'Target quantity',
  actualQuantity: 'Actual quantity',
  singleWeightText: 'Single weight',
  totalWeightText: 'Total weight',
  productionOutput: 'Production output',
  quantityBreak: 'Break quantity',
  quantityCrack: 'Crack quantity',
  quantityNOK: 'NOK quantity',
  quantityOK: 'OK quantity',
  rightCycleTimeSeconds: 'Right cycle time [s]',
  qmData: 'QM data',
  restData: 'Grate data',
  grateNo: 'Grate No.',
  spsNo: 'SPS No.',
  startTime: 'Start time',
  endTime: 'End time',
  previousEndTime: 'Previous end time',
  id: 'ID',
  treatment: 'Treatment',
  grateType: 'Grate type',
  zoneTimes: 'Zone times',
  zoneEntranceTime: 'Zone entrance time',
  zoneExitTime: 'Zone exit time',
  zone1EntryTime: 'Zone 1 entry time',
  zone1ExitTime: 'Zone 1 exit time',
  zone2EntryTime: 'Zone 2 entry time',
  zone2ExitTime: 'Zone 2 exit time',
  specialColor: 'Special color',
};
